import { viewElement } from '@hotjar/tracking';
import { PAGE } from './click';

export enum ELEMENT_NAME {
  paymentDetailsEmpty = 'Payment Detail Page - empty',
  paymentDetails = 'Payment Details Page - payment method available',
  paymentDetailsOverdueAlert = 'Payment Details Page - overdue alert',
  globalAccountOwnerOverdueAlert = 'Payment Alert - account owner overdue alert',
  globalNonAccountOwnerOverdueAlert = 'Payment Alert - non-account owner overdue alert',
}

const UI_POSITION = {
  ...PAGE,
  navigation: 'Navigation',
} as const;

interface ViewElementProps {
  name: ELEMENT_NAME;
  accountId: number;
  uiPosition: (typeof UI_POSITION)[keyof typeof UI_POSITION];
}

export const trackViewElement = ({ name, uiPosition, accountId }: ViewElementProps): void => {
  viewElement({
    name,
    uiPosition,
    groupData: {
      account_id: accountId,
    },
  });
};
